import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CallBar } from './CallBar';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-jk-ink pb-16 text-white sm:pb-0" data-id="element-84" data-mp="uzcnwa2v1ocn">
      <Header data-id="element-85" data-mp="79s2lkj8if07" />
      <main className="flex-1" data-id="element-86" data-mp="79ic7vua25tz">
        <Outlet data-id="element-87" data-mp="76dzga2qy1rp" />
      </main>
      <Footer data-id="element-88" data-mp="2a5ol8vl0uqc" />
      <CallBar data-id="element-89" data-mp="2af76bearzm0" />
    </div>;
}